export const useScrollSensor = (window: Ref<(Window & typeof globalThis) | undefined>) => {
  const lastScrollTop = ref(0);
  const isScrollingUp = ref(false);
  const isScrollingDown = ref(false);
  const handleScroll = () => {
    // vaulドロワー等でbodyがfixedになっている場合はスクロール方向の更新をスキップ
    if (document.body.style.position === 'fixed') return;
    const currentScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    // 同一位置の場合は処理不要
    if (currentScrollTop === lastScrollTop.value) return;
    isScrollingUp.value = currentScrollTop < lastScrollTop.value;
    isScrollingDown.value = currentScrollTop > lastScrollTop.value;
    lastScrollTop.value = currentScrollTop <= 0 ? 0 : currentScrollTop;
  };
  onMounted(() => {
    window.value?.addEventListener('scroll', handleScroll);
  });
  onUnmounted(() => {
    window.value?.removeEventListener('scroll', handleScroll);
  });

  return { isScrollingUp, isScrollingDown };
};
